module.exports = __webpack_public_path__ + "static/media/logo.2b686f2e.svg";